import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const VideoCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true, // This makes transitions smoother and prevents content flashing
    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    customPaging: function(i) {
      return (
        <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 md:w-3 md:h-3 rounded-full bg-white/40 hover:bg-white/80 transition-all duration-300"></div>
      );
    },
    dotsClass: "slick-dots custom-dots",
  };

  return (
    <div className="relative w-full">
      <Slider {...settings} className="w-full h-[600px] sm:h-[500px] md:h-[600px] lg:h-[750px] xl:h-[850px]">
        
        {/* Slide 1 - Quran */}
        <div className="relative w-full h-[600px] sm:h-[500px] md:h-[600px] lg:h-[750px] xl:h-[850px]">
          <video
            src="/images/landingvideo.mp4"
            className="object-cover w-full h-full"
            muted
            autoPlay
            loop
            playsInline
          />
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
          
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 sm:px-6 md:px-8 lg:px-12">
            {/* Arabic Text */}
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl xl:text-7xl mb-4 sm:mb-5 md:mb-6 font-light leading-tight max-w-5xl animate-fadeIn">
              وَلَقَدْ يَسَّرْنَا ٱلْقُرْءَانَ لِلذِّكْرِ فَهَلْ مِن مُّدَّكِرٍۢ
            </h1>
            
            {/* English Translation */}
            <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-light mb-6 sm:mb-8 md:mb-10 opacity-90 max-w-2xl leading-relaxed animate-fadeIn animation-delay-100">
              "And We have certainly made the Qur'an easy to remember.<br className="hidden sm:block"/>
              So is there anyone who will be mindful?"
            </p>
            
            {/* Button */}
            <Link
              to="/library"
              className="group relative text-white bg-white/10 backdrop-blur-md border-2 border-white/60 
                         px-6  py-3
                         text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl
                         rounded-xl font-black uppercase tracking-wider
                         hover:bg-white hover:text-gray-900 hover:border-white
                         transition-all duration-300 
                         hover:scale-105 hover:shadow-2xl
                         overflow-hidden
                         animate-fadeIn animation-delay-200"
            >
              <span className="relative z-10">Quran Library</span>
              <div className="absolute inset-0 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
            </Link>
          </div>
        </div>

        {/* Slide 2 - Hadees */}
        <div className="relative w-full h-[600px] sm:h-[500px] md:h-[600px] lg:h-[750px] xl:h-[850px]">
          <video
            src="/images/masjidland.mp4"
            className="object-cover w-full h-full"
            muted
            autoPlay
            loop
            playsInline
          />
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
          
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 sm:px-6 md:px-8 lg:px-12">
            {/* Arabic Text */}
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl xl:text-7xl mb-4 sm:mb-5 md:mb-6 font-light leading-tight max-w-5xl animate-fadeIn">
              ٱللَّهُ نَزَّلَ أَحْسَنَ ٱلْحَدِيثِ كِتَـٰبًۭا
            </h1>
            
            {/* English Translation */}
            <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-light mb-6 sm:mb-8 md:mb-10 opacity-90 max-w-2xl leading-relaxed animate-fadeIn animation-delay-100">
              "Allah has sent down the best statement:<br className="hidden sm:block"/>
              a consistent Book wherein is reiteration"
            </p>
            
            {/* Button */}
            <Link
              to="/library"
              className="group relative text-white bg-white/10 backdrop-blur-md border-2 border-white/60 
                         px-6  py-3
                         text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl
                         rounded-xl font-black uppercase tracking-wider
                         hover:bg-white hover:text-gray-900 hover:border-white
                         transition-all duration-300 
                         hover:scale-105 hover:shadow-2xl
                         overflow-hidden
                         animate-fadeIn animation-delay-200"
            >
              <span className="relative z-10">Hadees Library</span>
              <div className="absolute inset-0 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
            </Link>
          </div>
        </div>

        {/* Slide 3 - Seerat */}
        <div className="relative w-full h-[600px] sm:h-[500px] md:h-[600px] lg:h-[750px] xl:h-[850px]">
          <video
            src="/images/masjidland.mp4"
            className="object-cover w-full h-full"
            muted
            autoPlay
            loop
            playsInline
          />
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
          
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 sm:px-6 md:px-8 lg:px-12">
            {/* Arabic Text */}
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl xl:text-7xl mb-4 sm:mb-5 md:mb-6 font-light leading-tight max-w-5xl animate-fadeIn">
              وَمَا أَرْسَلْنَاكَ إِلَّا رَحْمَةً لِّلْعَالَمِينَ
            </h1>
            
            {/* English Translation */}
            <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-light mb-6 sm:mb-8 md:mb-10 opacity-90 max-w-2xl leading-relaxed animate-fadeIn animation-delay-100">
              "And We have not sent you, [O Muhammad],<br className="hidden sm:block"/>
              except as a mercy to the worlds"
            </p>
            
            {/* Button */}
            <Link
              to="/library"
              className="group relative text-white bg-white/10 backdrop-blur-md border-2 border-white/60 
                          px-6  py-3
                         text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl
                         rounded-xl font-black uppercase tracking-wider
                         hover:bg-white hover:text-gray-900 hover:border-white
                         transition-all duration-300 
                         hover:scale-105 hover:shadow-2xl
                         overflow-hidden
                         animate-fadeIn animation-delay-200"
            >
              <span className="relative z-10">Seerat Library</span>
              <div className="absolute inset-0 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
            </Link>
          </div>
        </div>

      </Slider>

      {/* Custom Styles */}
      <style jsx>{`
        /* Custom Dots Styling */
        .custom-dots {
          bottom: 20px !important;
        }
        
        .custom-dots li {
          margin: 0 4px !important;
        }
        
        .custom-dots li.slick-active div {
          background-color: white !important;
          width: 32px !important;
          border-radius: 9999px !important;
        }
        
        @media (min-width: 640px) {
          .custom-dots {
            bottom: 30px !important;
          }
          .custom-dots li {
            margin: 0 5px !important;
          }
          .custom-dots li.slick-active div {
            width: 40px !important;
          }
        }
        
        @media (min-width: 768px) {
          .custom-dots {
            bottom: 40px !important;
          }
          .custom-dots li {
            margin: 0 6px !important;
          }
          .custom-dots li.slick-active div {
            width: 48px !important;
          }
        }

        /* Fade In Animation - All content appears together */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.6s ease-out forwards;
          opacity: 0;
        }

        .animation-delay-100 {
          animation-delay: 0.1s;
        }

        .animation-delay-200 {
          animation-delay: 0.2s;
        }

        /* Fix for slick slider fade transition */
        .slick-slide {
          opacity: 0;
          transition: opacity 0.8s ease-in-out;
        }

        .slick-slide.slick-active {
          opacity: 1;
        }
      `}</style>
    </div>
  );
};

export default VideoCarousel;



// import React, { useEffect, useRef, useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Link } from "react-router-dom"; // Import Link from react-router-dom

// const VideoCarousel = () => {
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 5000,
//     arrows: false,
//   };

//   const [showQuranPopup, setShowQuranPopup] = useState(false);
//   const [showHadeesPopup, setShowHadeesPopup] = useState(false);
//   const [showSeeratPopup, setShowSeeratPopup] = useState(false);

//   const [quranErrorMessage, setQuranErrorMessage] = useState("");
//   const [hadeesErrorMessage, setHadeesErrorMessage] = useState("");
//   const [seeratErrorMessage, setSeeratErrorMessage] = useState("");

//   const popupRef = useRef(null); // Ref for the popup
//   const hadeespopupRef = useRef(null); // Add useRef here
//   const seeratpopupRef = useRef(null); // Add useRef here

//   const [selectedQuranLanguages, setSelectedQuranLanguages] = useState({
//     arabic: false,
//     english: false,
//     telugu: false,
//   });

//   const [selectedHadeesLanguages, setSelectedHadeesLanguages] = useState({
//     SahihAlBukhari: false,
//     SahihMuslim: false,
//     JamiAtTirmidhi: false,
//     SunanAbuDawood: false,
//     SunanAnNasai: false,
//     MusnadImamAhmadbiHanbal: false,
//   });

//   const [selectedSeeratLanguages, setSelectedSeeratLanguages] = useState({
//     arabicSeerat: false,
//     englishSeerat: false,
//     urduSeerat: false,
//     teluguSeerat: false,
//   });

//   return (
//     <div className="relative w-full">
//       <Slider {...settings} className="w-full h-[500px] lg:h-[850px]">
//         {/* Slide 1 */}
//         <div className="relative w-full md:w-full h-[500px] lg:h-[850px]">
//           <video
//             src="/images/landingvideo.mp4"
//             className="object-cover w-full md:w-full h-[500px] lg:h-[850px]"
//             muted
//             autoPlay
//             loop
//           />
//           <div className="absolute top-10 md:top-0 inset-0 flex flex-col items-center justify-center text-white text-center">
//             <p className="text-4xl md:text-4xl lg:text-7xl mb-4 font-serif font-semibold">
//               وَلَقَدْ يَسَّرْنَا ٱلْقُرْءَانَ لِلذِّكْرِ فَهَلْ مِن مُّدَّكِرٍۢ
//             </p>
//             <Link
//               to="/library" // Using Link to navigate to the PDF Library page for Quran
//               className="text-black py-2 px-4 rounded-lg border-2 border-black font-serif bg-white bg-transparent opacity-40"
//             >
//               Get Free Quran PDF
//             </Link>
//           </div>
//         </div>

//         {/* Slide 2 */}
//         <div className="relative w-full md:w-full h-[500px] lg:h-[850px]">
//           <video
//             src="/images/masjidland.mp4"
//             className="object-cover w-full md:w-full h-[500px] lg:h-[850px]"
//             muted
//             autoPlay
//             loop
//           />
//           <div className="absolute top-10 md:top-0 inset-0 flex flex-col items-center justify-center text-white text-center">
//             <p className="text-4xl md:text-4xl lg:text-7xl mb-4 font-serif font-semibold">
//               ٱللَّهُ نَزَّلَ أَحْسَنَ ٱلْحَدِيثِ كِتَـٰبًۭا
//             </p>
//             <Link
//               to="/library" // Using Link to navigate to the PDF Library page for Hadees
//               className="text-black py-2 px-4 rounded-lg border-2 border-black font-serif bg-white bg-transparent opacity-40"
//             >
//               Get Free Hadees PDF
//             </Link>
//           </div>
//         </div>

//         {/* Slide 3 */}
//         <div className="relative w-full md:w-full h-[500px] lg:h-[850px]">
//           <video
//             src="/images/masjidland.mp4"
//             className="object-cover w-full md:w-full h-[500px] lg:h-[850px]"
//             muted
//             autoPlay
//             loop
//           />
//           <div className="absolute top-10 md:top-0 inset-0 flex flex-col items-center justify-center text-white text-center">
//             <p className="text-4xl md:text-4xl lg:text-7xl mb-4 font-serif font-semibold">
//             وَمَا أَرْسَلْنَاكَ إِلَّا رَحْمَةً لِّلْعَالَمِينَ
//             </p>
//             <Link
//               to="/library" // Using Link to navigate to the PDF Library page for Seerat
//               className="text-black py-2 px-4 rounded-lg border-2 border-black font-serif bg-white bg-transparent opacity-40"
//             >
//               Get Free Seerat PDF
//             </Link>
//           </div>
//         </div>
//       </Slider>
//     </div>
//   );
// };

// export default VideoCarousel;

